import React from 'react';
import './header.css';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'react-bootstrap/Image';
import logo from '../../img/logo.png';
import Forms from '../forms/Contact';



function Header() {
  return (
    <Navbar id="header" expand="lg" className="bg-body-tertiary">
      <Container>
        <a href="/"><Image  id="Home" className='Image' src={logo} fluid /></a>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/#Projects">Projects</Nav.Link>
            <Nav.Link href="/#Services">Services</Nav.Link>          
            <Nav.Link href="/#Clients">Clients</Nav.Link>
            <Nav.Link href="/#contact-form">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;